import { OriginInfo } from "@/types";

export const trainStationCodeMap = new Map<string, OriginInfo>([
    ["STP", { name: "London Saint Pancras" }],
  ]);
  